import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Input, Button } from 'antd'
import { requiredMessage, inputPlace, successNotification, errorMessage, assignMessage } from '../../utils/helpers'
import { allPaths } from '../../utils/constants'
import { LoginHeader } from '../../Components'
import axios from 'axios'
import { AUTH } from '../../utils/apis'
import { loginUser, removeUser } from '../../Redux/actions/authActions'
import WGP_logo_Text from '../../assets/WGP-white.png'

const Login = (props) => {
    const { language, selectedLanguage } = props
    const history = useHistory()
    const dispatch = useDispatch()
    const isEnglish = language?.language === 'english'

    const [loading, setLoading] = useState(false)
    const path = history?.location?.pathname
    const onFinish = (value) => {
        value.userType = 'player'
        setLoading(true)
        axios.post(AUTH.LOGIN, value)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data.success) {
                    successNotification(selectedLanguage?.message_SuccessfullyLoggedIn)
                    dispatch(loginUser(data.user))
                    return setTimeout(() => {
                        history?.replace(allPaths?.HOME)
                    }, 300)
                }
                errorMessage(assignMessage(data.message, language?.language))
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e.message, language?.language))
            })
    }

    useEffect(() => {
        dispatch(removeUser())
    }, [])
    return (
        <div>
            <LoginHeader />
            <div className='auth-screen-main-div-new sidebar-scroll_class'>
                <center>
                    <img src={WGP_logo_Text} className='img-for-login-page' />
                </center>
                <p className='heading head-center' style={{ color: 'white' }}>{selectedLanguage?.title_Login}</p>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                >
                    <div className='form-two-input-flex'>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='email'
                                label={<p className='p-admin-title-text'>{selectedLanguage?.label_Email}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.error_PleaseEnterYourEmail
                                    },
                                    {
                                        type: 'email',
                                        message: selectedLanguage?.error_EmailIsNotValid
                                    },
                                ]}
                            >
                                <Input
                                    className='form-input-new-design-big-slam'
                                    placeholder={selectedLanguage?.placeHolder_PleaseEnterYourEmail}
                                />
                            </Form.Item>
                        </div>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='password'
                                label={<p className='p-admin-title-text'>{selectedLanguage?.label_Password}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.error_PleaseEnterYourPassword
                                    },
                                    {
                                        min: 8,
                                        message: selectedLanguage?.error_PasswordMustBeAtLeastEightCharacters
                                    }
                                ]}
                            >
                                <Input.Password
                                    className='form-input-new-design-big-slam'
                                    placeholder={selectedLanguage?.PlaceHolder_PleaseEnterYourPasswordHere}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <Form.Item>
                        <Button
                            className='login-btn-height'
                            type='primary'
                            htmlType='submit'
                            block
                            loading={loading}
                        >
                            {selectedLanguage?.ButtonText_Submit}
                        </Button>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <p style={{ color: 'white' }}>{selectedLanguage?.minTitle_DontHaveAnAccount}
                                <Link className='linkStyle' to={allPaths?.SIGNUP}>{selectedLanguage?.minTitle_SignUp}</Link>
                                <br />
                                <Link className='linkStyle' to={allPaths?.FORGOT_PASSOWRD}>{selectedLanguage?.minTitle_ForgotPassword}</Link>
                            </p>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}


export default Login